import React from "react";
import Fade from "react-reveal/Fade";
import ReactTypingEffect from "react-typing-effect";
import { Container } from "react-bootstrap";
import './about.css';
import Flash from '../assets/flash.svg';
export default function about() {
    return (
        <Container fluid className="px-0">
            <Container className="bts-about-wrapper">
                <div>
                    <div className="">
                        <Fade delay={500}>
                            <span className="blueText d-flex justify-content-center b7 medium">About Us</span>
                        </Fade>
                        <div className="text-center">With a proven track record and a mature</div>
                        <div className="text-center">approach to the industry, we provide</div>
                        <div className="text-center">reliable trading of cryptocurrencies.</div>
                    </div>
                </div>
            </Container>
            <div className="bts-trade-section whiteText">
                <Fade bottom delay={400}>
                    <div className="smallText text-center pb-3">We trade <img src={Flash} alt="" className="flash"/></div>
                </Fade>
                <Fade bottom delay={500}>
                    <div className="bigText b7 text-center">
                        <ReactTypingEffect
                            text={["Litecoin", "Bitcoin", "Ethereum", "Dash", "USDT"]}
                            speed={150}
                            eraseDelay={700}
                            typingDelay={300}
                        />
                    </div>
                </Fade>
            </div>
        </Container>
    )
}
